import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logoutUser } from "../store/slice/features/authSlice";
import { destinations } from '../data/destinationsData';
import './RightSideSlideMenu.css';
import '../css/header.css';

const menuData = {
  "JTDC": {
    "About Us": ["About Us", "Structure", "Events"],
    "Public Notices": ["Latest Notices", "Tender Announcements"]
  },
  "Hotels": {
    "Rooms & Packages": ["Book Stay", "Package", "Vehicle Booking Tariff (pdf)"],
    "Manage Bookings": ["Booking History"]
  },
  "Explore": {
    "Tours": ["Mining Tours"],
    "Media": ["Media Vault"]
  },
  "Account": {
    "Existing Account": ["Log In", "Reset Password", "My Bookings", "Profile", "Log Out"],
    "New Account": ["Sign Up"],
    "Officials":["Dashboard","HRMS"],
   
  },
  // "Destinations": {
  //   "": destinations.map((d) => d.title)
  // },
  "Help": {
    "Guide": ["User Manual (pdf)"],
    "Policy": ["Booking T&C (pdf)"]
  },
};

const backgroundImages = {
  "JTDC": "/images/testimage/pic2.webp",
  "Hotels": "/images/testimage/pic5.webp",
  "Explore": "/images/testimage/pic9.webp",
  "Account": "/images/testimage/pic8.webp",
  "Help": "/images/testimage/pic7.webp",
  "Destinations": "/images/testimage/pic6.webp"
};

const menuBackgrounds = {
  "JTDC": "#0077b6",
  "Hotels": "#43aa8b",
  "Explore": "#a14f7cff",
  "Account": "#b06936ff",
  "Help": "#9850c2ff",
  "Destinations": "#d35400ff"
};

const routeMap = {
  // JTDC
  "About Us": "/About",
  "Events": "/events",
  "Structure": "/organizational-structure",
  "Latest Notices": "/notice",
  "Tender Announcements": "/tenders",

  // Hotels
  "Book Stay": "/allhotel",
  "Package": "/advanceBooking",
  "Reschedule Booking": "/rescheduleBooking",
  "Booking History": "/booking-history",
  "Vehicle Booking Tariff (pdf)": "/pdfs/vehicle-tariff.pdf",

  // Explore
  "Mining Tours": "/tours",
  "Media Vault": "/pdf-gallery",

  // Account
  "Log In": "/login",
  "Sign Up": "/signup",
  "My Bookings": "/booking-history",
  "Reset Password": "/forgot-password",
  "Profile": "/my-account",
  "Log Out": "#",
  "Dashboard":'https://jtdclportal.jharkhand.gov.in/signin',
  "HRMS":'https://jtdclportal.jharkhand.gov.in/hrms/login',


  // Help (PDFs)
  "User Manual (pdf)": "/pdfs/user-manual.pdf",
  "Booking T&C (pdf)": "/pdfs/booking-terms-and-conditions.pdf"
};

const RightSideSlideMenu = () => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const lastScrollYRef = useRef(0);
  const [showHeader, setShowHeader] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(Object.keys(menuData)[0]);
  const isAuthenticated = !!(user && user.EmailId);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [expandedMenus, setExpandedMenus] = useState({});

  // Helper to render each menu item
  const renderMenuItem = (item) => {
    const pdfItems = ["User Manual (pdf)", "Booking T&C (pdf)", "Vehicle Booking Tariff (pdf)"];

    // PDF links
    if (pdfItems.includes(item)) {
      return (
        <a
          href={routeMap[item]}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => setIsOpen(false)}
          style={{ color: '#ffd700' }}
        >
          {item}
        </a>
      );
    }

    // Dynamic destinations
    const destinationObj = destinations.find(d => d.title === item);
    if (destinationObj) {
      return (
        <Link
          to={`/destination/${destinationObj.id}`}
          onClick={() => setIsOpen(false)}
          style={{ color: '#ffd700' }}
        >
          {item}
        </Link>
      );
    }

    switch (item) {
      case "Log In":
        return <Link to="/login" onClick={() => setIsOpen(false)} style={{ color: '#ffd700' }}>{item}</Link>;
      case "My Bookings":
        return <Link to="/booking-history" onClick={() => setIsOpen(false)} style={{ color: '#ffd700' }}>{item}</Link>;
      case "Log Out":
        return <button className="logout-btn" onClick={handleLogout} style={{ backgroundColor: '#db491acc', padding: '10px' }}>{item}</button>;
      case "Sign Up":
        return <Link to="/signup" onClick={() => setIsOpen(false)} style={{ color: '#ffd700' }}>{item}</Link>;
      default:
        return <Link to={routeMap[item] || "#"} onClick={() => setIsOpen(false)}>{item}</Link>;
    }
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
    setActiveMenu(Object.keys(menuData)[0]);
    setExpandedMenus({});
  };

  const handleLogout = async () => {
    await dispatch(logoutUser());
    setIsOpen(false);
    navigate("/login");
  };

  const handleMobileMenuClick = (menuItem) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [menuItem]: !prev[menuItem],
    }));
    setActiveMenu(menuItem);
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (!mobile) setExpandedMenus({});
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setShowHeader(currentScrollY === 0 || currentScrollY < lastScrollYRef.current);
      lastScrollYRef.current = currentScrollY;
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`main-header ${showHeader ? "visible" : "hidden"}`}>
      <Link to="/" className={`fixed-logo ${showHeader ? "visible" : "hidden"}`} style={{ paddingLeft: "7px", paddingTop: "5px" }}>
        <img src="/images/logo/Logosforwebsite.webp" alt="logo" title="Logo" loading="lazy" className="mob-web-logo" style={{ height: "50px", objectFit: "contain" }} />
      </Link>

      <button className={`hamburger-btn ${showHeader ? "visible" : "hidden"}`} onClick={toggleMenu} style={{
        display: isOpen ? "none" : "block",
        fontSize: "35px",
        padding: "5px 10px",
        background: "linear-gradient(to right, #1a1a2e, #16213e, #0f3460)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        border: "none",
        position: "absolute",
        right: "20px",
        top: "12px",
        cursor: "pointer"
      }}>☰</button>

      {isOpen && (
        <div className="menu-container">
          {!isMobile && <div className="left-panel" style={{ backgroundImage: `url(${backgroundImages[activeMenu]})` }} />}
          <div className={`right-panel expanded ${isMobile ? 'mobile' : ''}`} style={{ backgroundColor: menuBackgrounds[activeMenu] || "#1a1a1a" }}>
            <button className="close-btn" onClick={toggleMenu}>×</button>
            <div className="menu-content-nested">
              <ul className="main-nav">
                {Object.keys(menuData).map((menuItem, idx) => (
                  <li key={idx}>
                    <div className="menu-title"
                      onClick={() => isMobile ? handleMobileMenuClick(menuItem) : setActiveMenu(menuItem)}
                      onMouseEnter={() => !isMobile && setActiveMenu(menuItem)}>
                      {menuItem === "Account" && isAuthenticated
                        ? <span style={{ color: "#ffeb3b", fontWeight: "bold" }}>{user?.EmailId?.split("@")[0] || "Account"}</span>
                        : menuItem}
                      {isMobile && <span className="plus-icon">{expandedMenus[menuItem] ? '−' : '+'}</span>}
                    </div>

                    {/* Mobile submenu */}
                    {isMobile && expandedMenus[menuItem] && (
                      <div className="submenu-nested">
                        {menuData[menuItem] && Object.entries(menuData[menuItem]).map(([subTitle, subItems], idx) => (
                          <div className="nested-column" key={idx}>
                            {subTitle && <h4 className="nav-head">{subTitle}</h4>}
                            <ul>
                              {subItems.map((item, i) => {
                                if (subTitle === "Existing Account" && item === "Log In" && isAuthenticated) return null;
                                if (subTitle === "Existing Account" && ["My Bookings", "Log Out"].includes(item) && !isAuthenticated) return null;
                                if (subTitle === "New Account" && isAuthenticated) return null;
                                if (subTitle === "Existing Account" && item === "Reset Password" && isAuthenticated) return null;
                                return <li key={i}>{renderMenuItem(item)}</li>;
                              })}
                            </ul>
                          </div>
                        ))}
                      </div>
                    )}
                  </li>
                ))}
              </ul>

              {/* Desktop submenu */}
              {!isMobile && menuData[activeMenu] && (
                <div className="submenu-nested">
                  {Object.entries(menuData[activeMenu]).map(([subTitle, subItems], idx) => (
                    <div className="nested-column" key={idx}>
                      {subTitle && <h4 className="nav-head">{subTitle}</h4>}
                      <ul>
                        {subItems.map((item, i) => {
                          if (subTitle === "Existing Account" && item === "Log In" && isAuthenticated) return null;
                          if (subTitle === "Existing Account" && ["My Bookings", "Log Out"].includes(item) && !isAuthenticated) return null;
                          if (subTitle === "New Account" && isAuthenticated) return null;
                          if (subTitle === "Existing Account" && item === "Reset Password" && isAuthenticated) return null;
                          return <li key={i}>{renderMenuItem(item)}</li>;
                        })}
                      </ul>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div style={{
              flexGrow: 1,
              backgroundImage: 'url(/images/new-header-illustrations-preview.png)',
              backgroundSize: '100% 130%',
              backgroundPosition: 'center'
            }} />
          </div>
        </div>
      )}
    </div>
  );
};

export default RightSideSlideMenu;